// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"347":"77c9e2a2","652":"006fd064"}[chunkId] + ".css";
};